import axios from 'axios';

export default {
  fetchAffiliate({
    commit,
  }, id) {
    return axios.get(`/affiliate/show/${id}`)
      .then((res) => {
        const hiddenFields = {
          fields: res.meta.invisibleFields,
          domain: 'affiliate',
        };

        commit('app/setHiddenFields', hiddenFields, {
          root: true,
        });

        return res;
      });
  },
  saveAffiliate(_, affiliate) {
    return axios.post('/affiliate', affiliate);
  },
  deleteAffiliateContactPerson(_, contactPerson) {
    return axios.delete(`/contactPerson/${contactPerson.id}`);
  },
};
